import produce from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ISportsbookState = {
    balances: [],
    isNeedToStart: false,
    isAppInitError: false,
    isAppInitialized: false,
    isAppInitializing: false,
    isIntegrationScriptError: false,
    isIntegrationScriptFetched: false,
    isIntegrationScriptFetching: false
};

export const reducer = produce((draftState, action: Types.TSportsbookAction): Types.ISportsbookState | void => {
    switch (action.type) {
        case actionTypes.SPORTSBOOK_START: {
            Object.assign(draftState, {
                isNeedToStart: true
            });

            break;
        }

        case actionTypes.SPORTSBOOK_BALANCES_UPDATE: {
            Object.assign(draftState, {
                balances: action.payload
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_FETCHING: {
            Object.assign(draftState, {
                isIntegrationScriptError: false,
                isIntegrationScriptFetched: false,
                isIntegrationScriptFetching: true
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_FETCHED: {
            Object.assign(draftState, {
                isIntegrationScriptError: false,
                isIntegrationScriptFetched: true,
                isIntegrationScriptFetching: false
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_ERROR: {
            Object.assign(draftState, {
                isIntegrationScriptError: true,
                isIntegrationScriptFetched: false,
                isIntegrationScriptFetching: false
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INITIALIZED_UPDATE: {
            Object.assign(draftState, {
                isAppInitError: false,
                isAppInitializing: false,
                isAppInitialized: action.payload
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INITIALIZING_UPDATE: {
            Object.assign(draftState, {
                isAppInitError: false,
                isAppInitialized: false,
                isAppInitializing: true
            });

            break;
        }

        case actionTypes.SPORTSBOOK_INITIALIZE_ERROR: {
            Object.assign(draftState, {
                isAppInitError: true,
                isAppInitialized: false,
                isAppInitializing: false
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
